var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-left" },
    [
      _c("h5", [
        _c("span", {
          staticClass: "uppercase",
          domProps: {
            textContent: _vm._s(_vm.t("forms.new_contractor_company.IC_0030")),
          },
        }),
      ]),
      _vm._v(" "),
      _c("span", {
        staticClass: "button mini radius no-margin",
        domProps: { textContent: _vm._s(_vm.t("register.copy_admin_info")) },
        on: { click: _vm.copyAddress },
      }),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", {
        staticClass: "panel",
        domProps: {
          textContent: _vm._s(_vm.t("forms.new_contractor_company.IC_0031")),
        },
      }),
      _vm._v(" "),
      _c("label", [
        _c("span", {
          domProps: {
            textContent: _vm._s(_vm.t("forms.new_contractor_company.IC_0032")),
          },
        }),
        _vm._v(" "),
        _c("i", {
          staticClass: "fa fa-question-circle",
          on: {
            click: function ($event) {
              _vm.showLegalNameModal = true
            },
          },
        }),
        _vm._v(" "),
        _c("i", {
          staticClass: "text-red",
          domProps: {
            textContent: _vm._s(_vm.t("register.change_company_name")),
          },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localData.memberInfo.Name,
              expression: "localData.memberInfo.Name",
            },
          ],
          attrs: { type: "text", disabled: "" },
          domProps: { value: _vm.localData.memberInfo.Name },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.localData.memberInfo, "Name", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("label", [
        _c("span", {
          domProps: {
            textContent: _vm._s(_vm.t("forms.new_contractor_company.IC_0042")),
          },
        }),
        _vm._v(" "),
        _c("i", {
          staticClass: "fa fa-question-circle",
          on: {
            click: function ($event) {
              _vm.showOperatingAsModal = true
            },
          },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localData.memberInfo.OperatingAs,
              expression: "localData.memberInfo.OperatingAs",
            },
          ],
          attrs: { type: "text" },
          domProps: { value: _vm.localData.memberInfo.OperatingAs },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.localData.memberInfo,
                "OperatingAs",
                $event.target.value
              )
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("label", { staticClass: "bottomMargin" }, [
        _c("span", {
          domProps: {
            textContent: _vm._s(_vm.t("forms.new_contractor_company.IC_0033")),
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "required" }, [_vm._v("*")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localData.memberInfo.Street,
              expression: "localData.memberInfo.Street",
            },
          ],
          staticClass: "no-margin",
          attrs: { type: "text" },
          domProps: { value: _vm.localData.memberInfo.Street },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.localData.memberInfo, "Street", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _vm.streetError && _vm.displayError
          ? _c("small", {
              staticClass: "error",
              domProps: {
                textContent: _vm._s(
                  _vm.t("xajax.mycontactinfo.server.IC_0014")
                ),
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("label", { staticClass: "bottomMargin" }, [
        _c("span", {
          domProps: {
            textContent: _vm._s(_vm.t("forms.new_contractor_company.IC_0034")),
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "required" }, [_vm._v("*")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localData.memberInfo.City,
              expression: "localData.memberInfo.City",
            },
          ],
          staticClass: "no-margin",
          attrs: { type: "text" },
          domProps: { value: _vm.localData.memberInfo.City },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.localData.memberInfo, "City", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _vm.cityError && _vm.displayError
          ? _c("small", {
              staticClass: "error",
              domProps: {
                textContent: _vm._s(
                  _vm.t("xajax.mycontactinfo.server.IC_0015")
                ),
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("label", { staticClass: "bottomMargin" }, [
        _c("span", {
          domProps: {
            textContent: _vm._s(_vm.t("forms.new_contractor_contact.IC_0011")),
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "required" }, [_vm._v("*")]),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.localCountryId,
                expression: "localCountryId",
              },
            ],
            staticClass: "no-margin",
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.localCountryId = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          [
            _c("option", {
              attrs: { value: "0" },
              domProps: {
                textContent: _vm._s(_vm.t("admin.edit_question.IC_0000")),
              },
            }),
            _vm._v(" "),
            _vm._l(_vm.displayData.geoInfo.countries, function (country) {
              return _c("option", {
                domProps: {
                  value: country.CountryID,
                  textContent: _vm._s(country.Name),
                },
              })
            }),
          ],
          2
        ),
        _vm._v(" "),
        _vm.countryError && _vm.displayError
          ? _c("small", {
              staticClass: "error",
              domProps: {
                textContent: _vm._s(
                  _vm.t("xajax.mycontactinfo.server.IC_0017")
                ),
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.localCountryId !== "0"
        ? _c("label", { staticClass: "bottomMargin" }, [
            _c("span", {
              domProps: {
                textContent: _vm._s(
                  _vm.t("forms.new_contractor_contact.IC_0010")
                ),
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "required" }, [_vm._v("*")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localProvinceId,
                    expression: "localProvinceId",
                  },
                ],
                staticClass: "no-margin",
                on: {
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.localProvinceId = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                },
              },
              [
                _c("option", {
                  attrs: { value: "0" },
                  domProps: {
                    textContent: _vm._s(_vm.t("admin.edit_question.IC_0000")),
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.getProvinces(), function (province) {
                  return _c("option", {
                    domProps: {
                      value: province.zone_id,
                      innerHTML: _vm._s(province.Name),
                    },
                  })
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm.provinceError && _vm.displayError
              ? _c("small", {
                  staticClass: "error",
                  domProps: {
                    textContent: _vm._s(
                      _vm.t("xajax.mycontactinfo.server.IC_0016")
                    ),
                  },
                })
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("label", { staticClass: "bottomMargin" }, [
        _c("span", {
          domProps: {
            textContent: _vm._s(_vm.t("forms.new_contractor_company.IC_0037")),
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "required" }, [_vm._v("*")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localData.memberInfo.Postal,
              expression: "localData.memberInfo.Postal",
            },
          ],
          staticClass: "no-margin",
          attrs: { type: "text" },
          domProps: { value: _vm.localData.memberInfo.Postal },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.localData.memberInfo, "Postal", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _vm.postalError && _vm.displayError
          ? _c("small", {
              staticClass: "error no-margin",
              domProps: {
                textContent: _vm._s(
                  _vm.t("xajax.mycontactinfo.server.IC_0018")
                ),
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.postalMatchError && _vm.displayError
          ? _c("small", {
              staticClass: "error",
              domProps: {
                textContent: _vm._s(_vm.t("member_basic_edit.IC_0115")),
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("label", { staticClass: "bottomMargin" }, [
        _c("span", {
          domProps: {
            textContent: _vm._s(_vm.t("forms.new_contractor_company.IC_0038")),
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "required" }, [_vm._v("*")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localData.memberInfo.MainTel,
              expression: "localData.memberInfo.MainTel",
            },
          ],
          staticClass: "no-margin",
          attrs: { type: "text" },
          domProps: { value: _vm.localData.memberInfo.MainTel },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.localData.memberInfo, "MainTel", $event.target.value)
            },
          },
        }),
        _vm._v(" "),
        _vm.mainTelError && _vm.displayError
          ? _c("small", {
              staticClass: "error",
              domProps: {
                textContent: _vm._s(
                  _vm.t("xajax.mycontactinfo.server.IC_0011")
                ),
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("label", [
        _c("span", {
          domProps: {
            textContent: _vm._s(_vm.t("forms.new_contractor_company.IC_0039")),
          },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localData.memberInfo.MainFax,
              expression: "localData.memberInfo.MainFax",
            },
          ],
          attrs: { type: "text" },
          domProps: { value: _vm.localData.memberInfo.MainFax },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.localData.memberInfo, "MainFax", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("label", [
        _c("span", {
          domProps: {
            textContent: _vm._s(_vm.t("forms.new_contractor_company.IC_0040")),
          },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localData.memberInfo.MainEmail,
              expression: "localData.memberInfo.MainEmail",
            },
          ],
          attrs: { type: "text" },
          domProps: { value: _vm.localData.memberInfo.MainEmail },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.localData.memberInfo,
                "MainEmail",
                $event.target.value
              )
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("label", [
        _c("span", {
          domProps: {
            textContent: _vm._s(_vm.t("forms.new_contractor_company.IC_0041")),
          },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localData.memberInfo.Website,
              expression: "localData.memberInfo.Website",
            },
          ],
          attrs: { type: "text" },
          domProps: { value: _vm.localData.memberInfo.Website },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.localData.memberInfo, "Website", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("label", [
        _c("span", {
          domProps: { textContent: _vm._s(_vm.t("member_basic_edit.IC_0073")) },
        }),
        _vm._v(" "),
        _vm.taxMandatory
          ? _c("span", { staticClass: "required" }, [_vm._v("*")])
          : _vm._e(),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.trim",
              value: _vm.localData.memberInfo.GST,
              expression: "localData.memberInfo.GST",
              modifiers: { trim: true },
            },
          ],
          attrs: { type: "text" },
          domProps: { value: _vm.localData.memberInfo.GST },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(
                _vm.localData.memberInfo,
                "GST",
                $event.target.value.trim()
              )
            },
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
        _vm._v(" "),
        _vm.taxError && _vm.displayError
          ? _c("small", {
              staticClass: "error",
              domProps: {
                textContent: _vm._s(
                  _vm.t("xajax.newcontractor.server.IC_0072")
                ),
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "columns large-4" }, [
          _vm._v("\n       \n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "columns large-4" }, [
          _c("button", {
            staticClass: "tiny radius expand",
            domProps: { textContent: _vm._s(_vm.t("register.user_guide")) },
            on: { click: _vm.openGuide },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "columns large-1" }, [
          _vm._v("\n       \n    "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "columns large-3" }, [
          _c("button", {
            staticClass: "tiny radius expand",
            domProps: {
              textContent: _vm._s(_vm.t("member_basic_edit.IC_0013")),
            },
            on: { click: _vm.nextStep },
          }),
        ]),
      ]),
      _vm._v(" "),
      _vm.showLegalNameModal
        ? _c(
            "modal",
            {
              attrs: { size: "small", "show-close-button": true },
              on: {
                close: function ($event) {
                  _vm.showLegalNameModal = false
                },
              },
            },
            [_c("p", { domProps: { innerHTML: _vm._s(_vm.legalNameHtml) } })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showOperatingAsModal
        ? _c(
            "modal",
            {
              attrs: { size: "small", "show-close-button": true },
              on: {
                close: function ($event) {
                  _vm.showOperatingAsModal = false
                },
              },
            },
            [_c("p", { domProps: { innerHTML: _vm._s(_vm.operatingAsHtml) } })]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }